export default "__VITE_ASSET__COcZIryr__"